module.exports = __webpack_public_path__ + "static/media/sf_1100_gray.a10445ac5c2b77d5c268a4b94b4e64b8.png";